import React,{useEffect,useState} from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Switch from "react-switch";
import emptyImage from '../../../assets/images/empty.png'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { emptyPermission, loadPermissionsByRole, putPermission } from '../../../store/Actions/ActionRolesAndPermissions';
import InnerLoader from '../../../components/general/inner-loader/InnerLoader';

function PopupPermission({ open, setOpen, id, translate }) {
    const { dispatch, langLocal,navigate,mode } = AbstructVar()
    const { permissions, loadingpermissions } = useSelectorCustom()
    const [statusID, setstatusID] = useState(null);
    const [loadStatusID, setloadStatusID] = useState(false);
    const [tempPermissions , setTempPermissions] = useState([])
    useEffect(() => {
        dispatch(loadPermissionsByRole(id))
    }, [])
    useEffect(()=>{
        setTempPermissions(permissions)
    },[permissions])
    const changeCheck = (row) => {
        setstatusID(row.id);
        const updatedPermissions = permissions.map((perm) => {
            if (perm.id === row.id) {
                return { ...perm, status: !perm.status }; 
            }
            return perm;
        });
        setTempPermissions(updatedPermissions)
        let reverseStatus;
        if (row.status == true) {
            reverseStatus = 0;
        } else {
            reverseStatus = 1;
        }
        dispatch(putPermission( id, row.name, reverseStatus, setloadStatusID))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
                dispatch(emptyPermission())
            }}
            center
            classNames={{
                modal: `pop_center1 ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_center' style={{width: "600px"}} dir={langLocal=== 'ar' ? "rtl" : "ltr"} >
                <p style={{textAlign: 'center'}} className={mode === 'dark'? "darktext":"lighttext"}>{translate('edit_permission')}</p>
                <div className='permissions' >
                    {
                        loadingpermissions === false ?(
                            tempPermissions.map((pp) => {
                                return (
                                    <div className={`one_permission ${mode === 'dark' ? "boorder_pop_dark":"boorder_pop_light"} `} >
                                        <span className={mode === 'dark'? "darktext":"lighttext"} >{pp.name}</span>
                                        <Switch className='bottom_switch' onColor='#a0c95f' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={pp.status}  onChange={() => changeCheck(pp)}  />
                                    </div>
                                )
                            })
                        ): <InnerLoader />
                    }
                    {
                        (loadingpermissions === false && permissions.length === 0) &&(
                            <div className='div_empty' >
                                <img src={emptyImage} />
                            </div>
                        )
                    }
                </div>
            </div>
        </RModal>
    )
}

export default PopupPermission